import React, { Component } from 'react';
import { Button, Select, DatePicker,Modal, Row, Col, Input, Radio, message,Tooltip ,Icon, AutoComplete } from 'antd';
import ExportUtil from '../../../common/ExportUtil';
import { connect } from 'react-redux';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import dictCache from '../../../common/dictCache';
import format from '../../shared/format';
import TableC from '../../basicElement/TableC';
import { saveParams } from '../../../actions/noticeActions';
import SearchRetrieve from '../../common/SearchRetrieve.new.js';
import moment from 'moment';

const yearFormat = 'YYYY';
let year = moment().format(yearFormat);
const confirm = Modal.confirm;

const { Option } = Select;
const monthFormat = 'YYYY-MM';
const { MonthPicker } = DatePicker;
const TextArea = Input.TextArea;

class Filter extends Component {

    state = {
        maxDate:moment(),
        searchParams: { ...this.props.params },
        operable:true,
        businessList: [],
        areaList:[],
        diseaseList:[],
    }

    componentWillReceiveProps(nextProps) {
        const { params:{ yearMonth } } = this.props;
        if(yearMonth != nextProps.params.yearMonth)
        this.setState({ searchParams: nextProps.params});
    }

    search = () => {
        const { searchParams } = this.state;
        const params = {
            ...searchParams,
        };
        this.props.search(params);
    }

    export = () => {
        const { searchParams } = this.state;
        const params = {
            ...searchParams,
        };
        this.props.export(params);
    }

    disabledDate = (current) => {
        const { searchParams:{ nowMonth } } = this.state;
        const value = moment(nowMonth).valueOf();
        return current && current.valueOf() > value;
    }

    onChange = (searchParams) => {
        this.setState({ searchParams: { ...searchParams }});
    }

    handleChange = (value, key) => {
        let { searchParams } = this.state;
        switch (key) {
            case 'investigation':
            case 'pmUser':
            case 'talUser': {
                {
                const { value: id, text: name } = value;
                searchParams[`${key}Id`] = id;
                searchParams[`${key}Name`] = name;
                this.onChange(searchParams);
                break;
            }
        }
            default:
                searchParams[key] = value;
                this.onChange(searchParams);
        }
    }

    render() {
        const { 
            searchParams,
            operable,
        } = this.state;
        const { 
            yearMonth, 
            investigationName,
            talUserName,
            pmUserName,
        } = searchParams;
        return (
            <div className="filter-wrap" style={{ padding: 10, background: '#fff' }}>
            <div className="filter-item">
                <label className="filter-label">确认月份</label>
                <MonthPicker
                    format={monthFormat}
                    value={yearMonth ? moment(yearMonth) : null}
                    onChange={(date, dateString) => this.handleChange(dateString, 'yearMonth')}
                    disabledDate={this.disabledDate}
                    allowClear={false}
                    style={{width: 100, verticalAlign: 'middle'}}
                />
            </div>
            <div className="filter-item">
                <label className="filter-label">项目简称</label>
                <SearchRetrieve
                    keyword="investigationName"
                    style={{ width: 162 }}
                    placeholder="输入名称检索"
                    params={{ limit: 20 }}
                    value={investigationName}
                    url={API_URL.investigation.queryInvestigationByName}
                    config={{ id: "investigationId", name: "investigationName" }}
                    onChange={value => this.handleChange(value, 'investigation')}
                />
            </div>
            <div className="filter-item">
                <label htmlFor="" className="filter-label">PM</label>
                <SearchRetrieve
                    keyword='keyword'
                    style={{ width: 140 }}
                    placeholder="输入姓名/工号检索"
                    value={pmUserName}
                    params={{ limit: 20 }}
                    url={API_URL.investigation.queryUserByKey}
                    config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                    onChange={value => this.handleChange(value, 'pmUser')}
                />
            </div>
            <div className="filter-item">
                <label htmlFor="" className="filter-label">领域leader</label>
                <SearchRetrieve
                    keyword='leaderName'
                    style={{ width: 140 }}
                    placeholder="输入姓名/工号检索"
                    value={talUserName}
                    params={{ limit: 20 }}
                    url={API_URL.user.queryLeaderListForSearch}
                    config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                    onChange={value => this.handleChange(value, 'talUser')}
                />
            </div>
            <div className="filter-item">
                <Button type="primary" onClick={this.search}>统计</Button>
            </div>
        </div>
        )
    }
}

class InvComplete extends Component {
    constructor(props) {
        super(props);
        const { params:{ yearMonthNum, investigationName } } = props || {};
        // 绩效排行->查看更多-> 返回时带参回到 绩效排行的tab页
        this.state = {
            data: [],
            loading: false,
            sortParams: {},
            searchParams: {
                nowMonth: moment().format('YYYY-MM'),
                yearMonth: yearMonthNum ?  moment(yearMonthNum).format('YYYY-MM') : undefined,
                investigationName,
            },
            pagination: {
                pageSize: 10,
                current: 1,
            },
        }
    }
    

    componentDidMount() {
        this.getDate()
    }

    componentWillUnmount() {
        this.props.saveParams({ investigationName: undefined, yearMonthNum: undefined });
    }

    loadData = () => {
        const { sortParams, searchParams, pagination } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.home.queryInvFinishPercentConfirmList,
            data: {
                offset: current,
                limit: pageSize,
                ...sortParams,
                ...searchParams,
            },
            dataType: 'json',
            doneResult: res => {
                const { datas, totalCount } = res;
                pagination.total = totalCount;
                this.setState({
                    loading: false,
                    data: datas,
                    pagination,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    getDate = () => {
        dictCache.getDict('EFFECTIVE_DATE', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.home.queryEffectiveDate,
                data: {},
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            const { date } = res;
            const nowMonth = Number(moment(date).format('DD')) < 26 ?  moment(date).add(-1,'M').format('YYYY-MM') : moment(date).format('YYYY-MM');
            const { searchParams = {}, searchParams:{ yearMonth } } = this.state;
            this.setState({
            searchParams:{
                ...searchParams,
                nowMonth,
                yearMonth: yearMonth ? moment(yearMonth).format('YYYY-MM') : nowMonth,
            }},this.loadData);
        })
    }

    search = (params) => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({ pagination, searchParams: {...params} }, () => {
            this.loadData();
        });
    }

    setProject = (setSession, item, isCenter) => {
        setSession.invId = item.investigationId;
        setSession.invName = item.investigationName;
        setSession.investigationSiteCode = "";
        setSession.investigationSiteName = isCenter ? "中心汇总" : '';
        setSession.siteId = '';
        setSession.curRole = 'PM';
        this.setSession(setSession)
    };

    setSession = (setSession) => {
        if (Object.keys(setSession).length !== 0) {
            for (let [k, v] of Object.entries(setSession)) {
                sessionStorage[k] = v;
            }
        }
    }

    markNormal=(record)=>{
        const { investigationFinishPercentConfirmId, confirmPercentOneHundred } = record;
        const _this = this;
        confirm({
            title: '确认项目的“截止本月末完工%”=100%?',
            okText:'是',
            cancelText: '否，项目还未完成',
            onOk() {
                const options = {
                    method: 'POST',
                    url: API_URL.home.updateConfirmState,
                    data: {
                        investigationFinishPercentConfirmId,
                        confirmPercentOneHundred: 1,
                    },
                    dataType: 'json',
                    doneResult: res => {
                        message.success( res.success )
                        _this.loadData()
                    }
                }
                $.sendRequest(options);
            },
            onCancel() {
                const options = {
                    method: 'POST',
                    url: API_URL.home.updateConfirmState,
                    data: {
                        investigationFinishPercentConfirmId,
                        confirmPercentOneHundred: 0,
                    },
                    dataType: 'json',
                    doneResult: res => {
                        _this.setProject( {}, record )
                        location.href = '/#/invDetails';//跳转到项目信息配置页面
                    }
                }
                $.sendRequest(options);
                
            },
        });
    }

    getColumns = () => {
        const columns = [{
            title: '业务线',
            dataIndex: 'lineOfBusinessString',
            key: 'lineOfBusinessString',
            width: 80,
        }, {
            title: 'JDE主项目号',
            dataIndex: 'jdeMainCode',
            key: 'jdeMainCode',
            width: 120,
        }, {
            title: '项目简称',
            dataIndex: 'investigationName',
            key: 'investigationName',
            width: 160,
        }, {
            title: '项目计划结束时间',
            dataIndex: 'investigationPlanEndTime',
            key: 'investigationPlanEndTime',
            width: 80,
            render: text => text.slice(0,10)
        }, {
            title: '截止当月末完工%',
            dataIndex: 'currentMonthPercentShow',
            key: 'currentMonthPercentShow',
            width: 100,
        }, {
            title: '截止上月末完工%',
            dataIndex: 'lastMonthPercentShow',
            key: 'lastMonthPercentShow',
            width: 100,
        }, {
            title: '大项目经理',
            dataIndex: 'mainPmNameCode',
            key: 'mainPmNameCode',
            width: 100,
        }, {
            title: '领域leader',
            dataIndex: 'invTalNameCode',
            key: 'invTalNameCode',
            width: 100,
        }];
            columns.push({
                title: '操作',
                dataIndex: 'option',
                key: 'option',
                fixed: 'right',
                width: 120,
                render: (text, record, index) => {
                    const { canConfirm, confirmPercentOneHundred } = record;
                    return  confirmPercentOneHundred ==1  ? <span >-</span> : canConfirm ? <a onClick={() => this.markNormal(record)} >确认完工到达100%</a> : <span style={{color: '#bfbfbf'}} >确认完工到达100%</span>
                },
            });
        return columns;
    }

    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    render() {
        const { exportable } = this.props;
        const { data, loading, pagination, searchParams, sortParams } = this.state;
        return (
            <div className="FinancialAnomalyReportContent">
                <div className='modTitle'>项目完工进度达到100%确认</div>
                <Filter
                    search={this.search}
                    params={searchParams}
                />
                <TableC
                    data={data}
                    loading={loading}
                    className="InvComplete"
                    sortParams={sortParams}
                    columns={this.getColumns()}
                    pagination={pagination}
                    onChange={this.handleTableChange}
                />
            </div>
        );
    }
}
const mapStateToProps = (state, props) => {
    return {
        params: state.noticeState.params,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        saveParams: (params) => dispatch(saveParams(params)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(InvComplete);


// WEBPACK FOOTER //
// ./src/components/homePage/myFocus/InvComplete.js